import type { FC } from 'react';

import React from 'react';
import Image from '@wix/thunderbolt-elements/src/components/Image/viewer/Image';
import { Avatar as AvatarWUT } from 'wix-ui-tpa/cssVars';

import VectorImage from '../../../../VectorImage/viewer/VectorImage';
import { AvatarState } from '../../../LoginSocialBar.types';
import { DEFAULT_AVATAR_SVG } from '../../../constants';

interface AvatarProps {
  id: string;
  size: number;
  name?: string;
  className?: string;
  url?: string;
  state?: AvatarState;
}

export const Avatar: FC<AvatarProps> = ({
  state,
  url,
  id,
  size,
  name,
  className,
}) => {
  if (state === AvatarState.Initials) {
    return (
      <AvatarWUT
        data-hook={`initialsAvatar-${id}`}
        className={className}
        name={name}
      />
    );
  }

  if (state === AvatarState.Image && url) {
    return (
      <Image
        id={`customAvatar-${id}`}
        containerId={id}
        width={size}
        height={size}
        displayMode="fill"
        uri={url}
        name=""
        alt=""
        className={className}
      />
    );
  }

  return (
    <VectorImage
      id={`defaultAvatar-${id}`}
      className={className}
      svgContent={DEFAULT_AVATAR_SVG}
      shouldScaleStroke={false}
      withShadow={false}
    />
  );
};
